

import ArticleAPI from '../api/ArticleAPI'
import Layout from '../components/Layout'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { canoc } from '../managers/Utils';

const articleAPI = new ArticleAPI();

const Blogs = (props: any) => {

    return <Layout overrideStyle={{ backgroundColor: 'white' }}>
        <div style={{ marginTop: 40 }}>
            <h1>The ETA Blog</h1>
            <p>News, guides and more for the culture -- brought to you by ETA and our partners</p>
            <div style={{ marginTop: 40 }}>
                {props.articles && props.articles.map((item) => <a href={`/blog/${canoc(item.title, item.id)}`} style={{ color: 'black' }}><Row style={{marginBottom: 10, width: null }}>
                    <Col md style={{}}>
                        <div style={{backgroundImage: `url(${item.image_url})`, width: '100%', height: '200px', backgroundPosition: 'center', backgroundSize: 'cover'}}>
                        </div>
                    </Col>
                    <Col md style={{paddingTop: 20}}>
                        <h4>{item.title}</h4>
                        <p>{item.subheading}</p>
                    </Col>
                </Row></a>)}
            </div>
        </div>
        <style global jsx>{`
         h1 {
            font-size: 2.0rem;
         }   
        `}</style>
    </Layout>
}



Blogs.getInitialProps = async (ctx: any) => {
    const props: any = {};
    const articlesResp = await articleAPI.getStories(null, {includeAll: true, excludeCategory: ["automated_event_list"]});
    if (articlesResp && articlesResp.code !== -1) {
        props.articles = articlesResp;
    }
    return props;
}

export default Blogs